import React from 'react';
import { useNavigate } from 'react-router-dom';

import { PropsWithClassName } from '../types/index';

import icStar from '@/assets/ic_star.svg';
import { Button } from '@/components';
import { useBackgroundByContext } from '@/hooks/useBackgroundByContext';
import usePinsAccount from '@/hooks/usePinsAccount';
import ROUTES from '@/router/routes';
import { EnumContextGDT, EnumTeamContext } from '@/types/team';
import { PACKS_BY_NAME } from '@/utils';

export const BoxGoPremium = React.memo(
  ({
    className,
    showStar = false,
    context = EnumContextGDT.Summary,
  }: PropsWithClassName<{
    showStar?: boolean;
    context?: EnumContextGDT | EnumTeamContext;
  }>) => {
    const navigate = useNavigate();
    const { pinsData } = usePinsAccount();
    const bg = useBackgroundByContext({ context });

    const handleOnClick = () => {
      if (pinsData.isPremium) {
        navigate(ROUTES.myAccount);
      } else {
        navigate(ROUTES.myAccount, { state: PACKS_BY_NAME.PREMIUM });
      }
    };

    return (
      <div
        className={`bg-white rounded-md text-center cursor-pointer ${className}`}
        onClick={handleOnClick}
      >
        <figure>
          <img
            alt="PACK PREMIUM"
            className="rounded-tl-lg rounded-tr-lg imgTagResponsive w-full"
            decoding="async"
            loading="lazy"
            src={bg?.default}
            srcSet={`${bg?.default} 1x, ${bg?.retina} 2x`}
          />
        </figure>
        <div className="text-base px-6 text-left">
          <div className="flex items-start space-x-2 mt-5 mb-3">
            {showStar && <img alt="Star Icon" src={icStar} width={35} />}
            <div>
              <p className="text-base font-bold mb-2">
                ¡Convertite en un DT Premium!
              </p>
              <span className="font-medium text-gdt-gray-3">
                Obtené pines ilimitados para tus equipos de Primera y Fútbol 5.{' '}
              </span>
            </div>
          </div>
        </div>
        <Button
          className="w-[9.5rem] bg-gdt-status-yellow border-0 mt-3"
          type="button"
          variant="primary"
        >
          Obtener
        </Button>
      </div>
    );
  }
);

BoxGoPremium.displayName = 'BoxGoPremium';
